import { mainClient } from "../../apollo";
import { INQUIRY_DEPOSIT_ACCOUNT } from "../graphql/depositAccount";
import { GET_RECOMMENDER_INFO, GET_SERVER_LIST } from "../graphql/manageUser";

export const getServerList = () => {
  const result = mainClient.readQuery({
    query: GET_SERVER_LIST,
  });
  return result?.getServerList?.data ?? [];
};

export const getDepositAccount = () => {
  const result = mainClient.readQuery({
    query: INQUIRY_DEPOSIT_ACCOUNT,
  });
  return result?.inquiryDepositAccount ?? [];
};

export const getRecommendList = () => {
  const result = mainClient.readQuery({
    query: GET_RECOMMENDER_INFO,
  });
  return result?.getRecommenderInfo ?? [];
};
